export default __webpack_public_path__ + "static/media/profile-icon1.f666a2f0.jpg";